module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"onfield_pre_delivery.footer.signature":"<div>..................................</div>","onfield_pre_delivery.sign_warning":"กรุณาลงลายมือชื่อผู้เข้ารับบริการ และผู้ส่งมอบให้ครบถ้วน"}}')
  delete Component.options._Ctor
}
